import { useNavigate } from 'react-router-dom';
import { StagePill } from './StagePill';
import { latestComment, productTypeEmoji, timeAgo } from '../../lib/workflow';

export const QueueCard = ({ item, children, index = 0, showNotes = true, footer }) => {
  const navigate = useNavigate();
  const wf = item.workflow || {};
  const lastChange = item.stage === 'changes_requested' ? latestComment(wf, 'changes') : null;
  const open = () => navigate(`/etsy/${item.id}`);
  return (
    <div className="wf-card wf-card-hover wf-rise p-4 flex gap-4" style={{ animationDelay: `${Math.min(index, 10) * 45}ms` }} data-testid={`queue-card-${item.id}`}>
      <button onClick={open} className="shrink-0 w-20 h-20 rounded-2xl overflow-hidden bg-[#F7F3EC] flex items-center justify-center text-3xl" data-testid={`queue-card-thumb-${item.id}`}>
        {item.thumbnail_url ? <img src={item.thumbnail_url} alt={item.name} loading="lazy" className="w-full h-full object-cover" /> : <span aria-hidden>{productTypeEmoji(item.product_type)}</span>}
      </button>
      <div className="flex-1 min-w-0 space-y-2">
        <div className="flex items-start justify-between gap-2">
          <button onClick={open} className="text-left text-sm font-bold text-[#2D2623] line-clamp-2 hover:text-[#C85A32] transition-colors" data-testid={`queue-card-title-${item.id}`}>
            {item.status === 'processing' ? '✨ Generating listing…' : item.name}
          </button>
          <StagePill stage={item.stage} size="xs" testId={`queue-card-stage-${item.id}`} />
        </div>
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-[#9A8E85]">
          <span>📸 {item.media_count} media</span>
          {item.input_url && (
            <a href={item.input_url} target="_blank" rel="noreferrer" className="text-[#1E568B] hover:underline" data-testid={`queue-card-source-${item.id}`}>
              🔗 source link
            </a>
          )}
          <span>🕒 {timeAgo(wf.stage_at || item.created_at)}</span>
          {item.etsy_listing?.listing_id && <span className="text-[#9A3412] font-semibold">🛒 Etsy draft pushed</span>}
          {wf.review_rounds > 1 && <span>🔄 round {wf.review_rounds}</span>}
        </div>
        {showNotes && wf.notes && (
          <div className="text-xs bg-[#FFF8EC] border border-[#F6E3C0] rounded-xl px-3 py-2 text-[#7A5B2E] whitespace-pre-line" data-testid={`queue-card-notes-${item.id}`}>
            📝 <b>{wf.submitted_by_name || 'Nayan'}:</b> {wf.notes}
          </div>
        )}
        {lastChange && (
          <div className="text-xs bg-[#FFF1F2] border border-[#FECDD3] rounded-xl px-3 py-2 text-[#9F1239] whitespace-pre-line" data-testid={`queue-card-changes-${item.id}`}>
            🔁 <b>{lastChange.by_name}:</b> {lastChange.text}
          </div>
        )}
        {footer}
        {children && <div className="flex flex-wrap items-center gap-2 pt-1">{children}</div>}
      </div>
    </div>
  );
};
